import request from '~/utils/http';

export function addSupplierBank(sendData) {
  return request({
    url: 'api/SupplierBank/Add',
    method: 'post',
    data: sendData
  })
}


export function getSupplierBanks(sendData) {
  return request({
    url: 'api/SupplierBank/GetListBySupplier',
    method: 'post',
    data: sendData
  })
}
